
import { defineComponent } from "vue";
import HomePage from "../components/HomePage.vue"; // @ is an alias to /src

export default defineComponent({
  name: "Home",
  components: {
    HomePage,
  },
});
